<div class="proj-review" *ngIf="count > 0 && !browsing">
  <!-- Needs-review cue -->
  <button #cueButton type="button" class="proj-review__cue" (click)="toggle()">
    <span class="proj-review__cue-text">
      <span class="proj-review__cue-title">{{ count }} possible {{ count === 1 ? 'project' : 'projects' }}</span>
      <span class="proj-review__cue-sub">Tap to confirm the right one</span>
    </span>
    <span class="proj-review__badge">
      REVIEW
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" [class.proj-review__chev--up]="open"><path d="m6 9 6 6 6-6"/></svg>
    </span>
  </button>

  <!-- Candidate picker -->
  <ng-container *ngIf="open">
    <div class="proj-review__menu">
      <div class="proj-review__menu-head">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.94 14.06A2 2 0 0 0 8.5 12.62l-5.6-1.45a.5.5 0 0 1 0-.96l5.6-1.45a2 2 0 0 0 1.44-1.44l1.45-5.6a.5.5 0 0 1 .96 0l1.45 5.6a2 2 0 0 0 1.44 1.44l5.6 1.45a.5.5 0 0 1 0 .96l-5.6 1.45a2 2 0 0 0-1.44 1.44l-1.45 5.6a.5.5 0 0 1-.96 0z"/></svg>
        <span>Suggested project matches</span>
      </div>
      <!-- Labels are EVIDENCE-GATED, never positional. tier 2 = the uniquely strongest candidate,
           1 = has name evidence but something ties it, 0 = none. When no candidate has evidence
           (hasEvidence false) the backend ranked on bare recency, so nothing is labelled and nothing is
           dimmed - the earlier "BEST" badge rendered on i === 0 regardless, which asserted a best MATCH
           about a project nothing had matched. -->
      <button type="button" class="proj-review__item"
        *ngFor="let c of candidates; trackBy: trackCandidate"
        [class.proj-review__item--weak]="hasEvidence && !c.tier"
        [disabled]="saving" (click)="confirm(c)">
        <span class="proj-review__item-text">
          <span class="proj-review__item-name">{{ c.projectName }}</span>
          <span class="proj-review__item-client" *ngIf="c.clientName">{{ c.clientName }}</span>
        </span>
        <span class="proj-review__best" *ngIf="c.tier === 2">Best match</span>
        <span class="proj-review__possible" *ngIf="c.tier === 1">Possible</span>
      </button>
      <p class="proj-review__error" *ngIf="errorMessage">{{ errorMessage }}</p>
      <button type="button" class="proj-review__browse" (click)="onBrowseAll()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
        Browse all projects…
      </button>
    </div>
  </ng-container>
</div>
